import { Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ICheckDinamicoPreguntas } from '../../model/modelCheckGarita';

@Component({
  selector: 'app-check-dinamico',
  templateUrl: './check-dinamico.component.html',
  styleUrls: ['./check-dinamico.component.css']
})
export class CheckDinamicoComponent implements OnInit {

  @Input() preguntas: ICheckDinamicoPreguntas[] = [];
  @Input() parentForm!: FormGroup; // Se inyecta desde el padre
  //@Output() respuestasForm = new EventEmitter<FormArray>();
  public opciones;
  preguntasFormArray!: FormArray;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    if (!this.parentForm) {
      throw new Error('El formulario padre (parentForm) es requerido');
    }
    this.addControls(this.preguntas, this.parentForm);
  }

  addControls(preguntas: ICheckDinamicoPreguntas[], form: FormGroup): void {
    preguntas.forEach((p) => {
      form.addControl(p.renderControl, this.fb.control('', Validators.required));
    });
  }

  addPreguntas(res){
    this.parentForm.clearValidators();
    res.forEach(e => {
      const preguntaGroup = this.fb.group({
        id        : [e.idItem],
        respuesta : ['', Validators.required]
      });
      //this.respuestasForm.push(preguntaGroup); 
    });
    this.parentForm.updateValueAndValidity();
  }
  /*
  onCheckboxChange(event: any, id: number, valor: string) {
    const control = this.parentForm.get(`pregunta_${id}`);
    const values = control?.value || [];
    if (event.target.checked) {
      control?.setValue([...values, valor]);
    } else {
      control?.setValue(values.filter((v: string) => v !== valor));
    }
  }*/
  
}
